import React from "react";
import {Link} from "react-router-dom";

type SettingsNavCardProps = {
    title: string;
    description: string;
    to: string;
    statusLabel: string;
    statusVariant: "success" | "warning" | "secondary";
};

const BADGE_CLASS: Record<SettingsNavCardProps["statusVariant"], string> = {
    success: "bg-success",
    warning: "bg-warning text-dark",
    secondary: "bg-secondary",
};

const SettingsNavCard: React.FC<SettingsNavCardProps> = ({
    title,
    description,
    to,
    statusLabel,
    statusVariant,
}) => (
    <div className="col-md-6 col-lg-3 mb-3">
        <Link to={to} className="text-decoration-none text-body d-block h-100">
            <div className="business-detail bg-orange-bland-zp bdr-20 pd-25 h-100 settings-nav-card">
                <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
                    <h2 className="fw-bold fs-20 mb-0">{title}</h2>
                    <span className={`badge flex-shrink-0 ${BADGE_CLASS[statusVariant]}`}>
                        {statusLabel}
                    </span>
                </div>
                <p className="text-muted mb-0 small">{description}</p>
            </div>
        </Link>
    </div>
);

export default React.memo(SettingsNavCard);
